const NoPage = () => {
    return <h1>404 - NOT FOUND</h1>;
};

export default NoPage;
